import angular from 'angular';
import 'angular-ui-router';
import ServicesModule from '../../services/services';
import ResourcesModule from '../../resources/resources';
import {fetchFullGameAndCallOnNext} from '../util/game-util.js';

export class CurrentGameHandlerController {
  /* @ngInject */
  constructor($state, $auth, $q, currentUser, currentGame, MeResource, GamesResource, GamesLimitedResource) {
    this.$state = $state;
    this.$q = $q;
    this.currentGame = currentGame;
    if ($auth.isAuthenticated()) {
      $q.all([GamesLimitedResource.getList(), MeResource.one().get()]).then(([games, user]) => {
        const vm = this;
        currentGame.subscribe((game) => {
          // when reloading the app this component gets loaded 2 times.
          // - first time with this.$state.current.name === ""
          // - second time with the correct state
          if(!game && vm.$state.current.name && !vm.otherComponentIsHandlingFullGameFetching()) {
            if (user.hasRole(['DEMO'])) {
              fetchFullGameAndCallOnNext(GamesResource, currentGame, 1560);
            } else {
              fetchFullGameAndCallOnNext(GamesResource, currentGame, games[0].id);
            }
          }
        });
      });
    }
    currentUser.subscribe(user => this.user = user);
    currentGame.subscribe(game => this.game = game);
  }

  otherComponentIsHandlingFullGameFetching() {
    // app.segments is fetching the current game in the router resolve.
    // updating currentGame here is wrong because it takes just the first of the games retrieved via the games/limited API.
    // in the segments views it leads to running those components with the wrong game config (the first returned by GamesLimitedResource.getList())
    // when logged in as ADMIN it that game would be probably even of another GD
    return /^(app.segments|app.games.index)/.test(this.$state.current.name);
  }
}

export function CurrentGameHandlerComponent() {
  return {
    //tamplate: '<div></div style="display=none">',
    controller: CurrentGameHandlerController,
    restrict: 'A',
    controllerAs: 'vm',
    scope: {},
    bindToController: true
  };
};

export default angular.module('currentGameHandler', [
  ServicesModule.name,
  ResourcesModule.name
])
  .directive('currentGameHandler', CurrentGameHandlerComponent);



/** WEBPACK FOOTER **
 ** ./src/common/appStateHandlers/currentGameHandler.js
 **/